module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Cascader', {
    ref: "toclearRef",
    attrs: {
      "checkStrictly": _vm.checkStrictly,
      "showalllevels": _vm.showalllevels,
      "placeholderLoad": _vm.placeholderLoad,
      "defaultProps": _vm.defaultProps,
      "editType": _vm.editType,
      "bindata": _vm.treedata,
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    on: {
      "setvalue": _vm.setvalue
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7faf3292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/CascaderList.vue
// module id = 1338
// module chunks = 5